import React from 'react';
import { Modal } from 'react-bootstrap';
import LoginView from '../views/LoginView';
import './AuthDialog.css';

export default function AuthDialog({
  show,
  onClose,
  title = 'Welcome to Pool 4 Real',
  subtitle = 'Sign in to continue with your player profile and shared app data.',
}) {
  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      restoreFocus
      dialogClassName="p4r-auth-dialog"
      contentClassName="p4r-auth-dialog__content"
      backdropClassName="p4r-auth-dialog__backdrop"
      aria-labelledby="p4r-auth-dialog-title"
    >
      <Modal.Header closeButton className="p4r-auth-dialog__header">
        <div>
          <Modal.Title id="p4r-auth-dialog-title" className="p4r-auth-dialog__title">
            {title}
          </Modal.Title>
          <p className="p4r-auth-dialog__subtitle">{subtitle}</p>
        </div>
      </Modal.Header>
      <Modal.Body className="p4r-auth-dialog__body">
        <LoginView onClose={onClose} onGuest={onClose} embedded />
      </Modal.Body>
    </Modal>
  );
}
